import React, { useState, useEffect, useContext, useRef } from 'react';
import DocumentService from "../../controller/DocumentController/DocumentController";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateDocument from './CreateDocument';
import HelpSite from "../../../Common/HelpLink";
import Cookies from "js-cookie";
import BASE_URL from "../../../../config/config";
import Swal from 'sweetalert2';
function DocumentListPage() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const [DocuemntList, setDocumentList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [formList, setFormList] = useState([]);
    const [currentDocument, setCurrentDocument] = useState(null);
    const [ModuleID, setModuleID] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`documentSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`documentSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    useEffect(() => {
        fetchForms();
        fetchDocument(ModuleID, currentPage, pageSize);
    }, [currentPage, pageSize, sortConfig, ModuleID]);



    const fetchDocument = async (ModuleID = 0, page, size) => {
        try {
            debugger;
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const list = await DocumentService.GetAllDocument(ModuleID, redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setDocumentList(list);
        } catch (error) {
            console.error('Error fetching Project Members:', error);
        }
    };

    const fetchForms = async (ClientID) => {
        try {
            const list = await ModuleService.GetAllModules();
            setFormList(list || []);
        } catch (error) {
            console.error('Error fetching Modules:', error);
        }
    };

    const handleCreateDocumentClick = async () => {

        setCurrentDocument(null);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleEditClick = async (document) => {
        setCurrentDocument(document); // Set the project member to be edited
        setShowModal(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await DocumentService.DeleteDocument(ID, redirectCallback); // Ensure this matches the actual function name in your service
                    await fetchDocument(ModuleID, "0", pageSize); // Fetch the updated list of project members

                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });


    };




    const handleFormSuccess = async () => {
        await fetchDocument(ModuleID, "0", pageSize);
        setShowModal(false);

    };

    const HelpLink = localStorage.getItem('HelpLink');

    const defaultColumns = [
        "DocumentName",
        "Description",
        "vc_ModuleName"
    ];
    const defaultColumnsForSearch = [
        "DocumentName",
        "Description",
        "vc_ModuleName"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "DocumentName", label: "DocumentName" },
        { value: "Description", label: "Description" },
        { value: "vc_ModuleName", label: "vc_ModuleName" }

    ];
    const columnSearchOptions = [
        { value: "DocumentName", label: "DocumentName" },
        { value: "Description", label: "Description" },
        { value: "vc_ModuleName", label: "vc_ModuleName" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`documentColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`documentColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await DocumentService.GetAllDocument(ModuleID, redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setDocumentList(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await DocumentService.GetAllDocument(ModuleID, redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setDocumentList(locationData);

    };
    const handleFieldChange = (e) => {
        setModuleID(e.target.value);
    };
    const handleSuccess = () => {
        fetchDocument(ModuleID, currentPage, pageSize); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const isImage = (fileName) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
    };
    const getFileExtension = (fileName) => {
        const index = fileName.lastIndexOf('.');
        return index !== -1 ? fileName.substring(index) : '';
    };
    const handleDownload = async (e, docuemnt) => {
        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);
        const customName = `${docuemnt.Name}${ext}`;

        try {
            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Admin/Documents/${docuemnt.FileName}`
            );
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = customName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className='btn btn-primary btn-sm' onClick={handleCreateDocumentClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Project Member" Module="26" />
                </div>
            </div>
            <div className="row mb-3">
                <label htmlFor="ProjectID" className="col-sm-2 col-form-label">Select Project:</label>
                <div className="col-sm-4">
                    <select
                        name="ModuleID"
                        className="form-control"
                        onChange={handleFieldChange}
                        value={ModuleID}
                    >
                        <option value="0">Select Module</option>
                        {formList.map((form) => (
                            <option
                                key={form.PK_SearchModule_ID}
                                value={form.PK_SearchModule_ID}
                            >
                                {form.vc_ModuleName}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>


            </div>
            <table className="table m-0 table-hover" ref={tableRef}>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Module</th>
                        <th>Attached File</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {DocuemntList.map((docuemnt) => (
                        <tr key={docuemnt.DocID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(docuemnt) : undefined}>
                            <td>{docuemnt.Name}</td>
                            <td>{docuemnt.Description}</td>
                            <td>{docuemnt.vc_ModuleName}</td>
                            <td>
                                <a
                                    href="#"
                                    onClick={(e) => handleDownload(e, docuemnt)}
                                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                >
                                    {`${docuemnt.Name}${getFileExtension(docuemnt.FileName)}`}
                                </a>
                            </td>


                            <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, docuemnt.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showModal && (
                <CreateDocument

                    currentDocument={currentDocument}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                />
            )}
        </div>
    );
}

export default DocumentListPage;
